import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UtilitiesService} from '../helpers/utilities.service';
import {catchError, map} from 'rxjs/operators';
import {Observable, of} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CompanyService {

    constructor(private http: HttpClient,
                private utils: UtilitiesService) {
    }

    public async getCompanyStand(id: string): Promise<any> {
        return await this.http.get<any>(this.utils.getCompanyStandApi(id)).toPromise();
    }

    public async getPartialCompanies(): Promise<any> {
        return await this.http.get(this.utils.getCompanyStandApi('partial')).toPromise();
    }
}
